var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            id: "confirmModal",
            title: _vm.modalAction.Title,
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h6", { staticClass: "my-4" }, [
                      _vm._v(_vm._s(_vm.filteredQueryMessage))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("ModalElements", {
            attrs: {
              actionUrl: _vm.modalAction.ActionUrl,
              recordId: [_vm.modalItem.RecordId],
              "after-action": _vm.afterAction
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6b13f22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6b13f22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/ConfirmModal.vue
// module id = null
// module chunks = 